export const error=[
    {
        path: 'error/forbidden',
        component: () => import('@/views/error-page/Error403.vue')
    }
]